<template>
    <div class="more-answer-wrapper">
        <Button
            :text="addLabel"
            :icon="addIcon"
            :hoverIcon="addIconHover"
            @btnClick="addClick"
            class="add-btn"
        />
        <div class="widget-thumbnails" v-if="isShowWidget">
            <ul class="thumb-list">
                <li
                    v-for="(tb, idx) in widgets"
                    class="thumbnail"
                    :key="idx"
                    @click="widgetClick(tb)"
                >
                    <i class="thumb-icon" :style="{ background: tb.icon }"></i>
                    <div class="thumb-text">{{ tb.text }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import i18n from "@/i18n";

export default {
    name: "SendActionMore",
    components: {
        Button,
    },
    data() {
        return {
            addIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px 0",
            addIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -56px -22px",
            widgetShow: false,
        };
    },
    computed: {
        isShowWidget() {
            return this.isEmpty || this.widgetShow;
        },
        selectLabel() {
            return this.$t("zhiji.answer.selectWidgets");
        },
        addLabel() {
            return this.$t("zhiji.answer.addWidget");
        },
        widgets() {
            const staticPath = this.zhiji.staticPath();
            return [
                {
                    wtType: "QuestionForm",
                    icon: "url('" + staticPath + "ico-mod-form.png') no-repeat",
                    text: i18n.t("zhiji.answer.form"),
                },
                {
                    wtType: "LinkTextInput",
                    icon: "url('" + staticPath + "ico-mod-txt.png') no-repeat",
                    text: i18n.t("zhiji.answer.text"),
                },
            ];
        },
    },
    methods: {
        addClick() {
            this.widgetShow = !this.widgetShow;
        },
        widgetClick(widget) {
            this.$emit("add", {
                wtType: widget.wtType,
            });
            this.widgetShow = false;
        },
        windowClick(event) {
            if (this.isShowWidget && !this.isEmpty && this.zhiji.isClickOuter(event, "more-answer-wrapper")) {
                this.widgetShow = false;
            }
        },
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
};
</script>

<style lang="less" scoped>
.more-answer-wrapper {
    position: relative;
    width: max-content;
    margin-bottom: 120px;
    margin-left: 30px;

    .widget-thumbnails {
        margin-left: 12px;
        top: -16px;

        z-index: 1;
        padding: 16px 8px 8px 16px;
        margin: 12px 0 0 0;
        margin-left: 0;
        width: max-content;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    }
}

.thumb-list {
    font-size: 0;
    padding: 0;
    .thumb-text {
        padding: 5px;
    }
}

.thumbnail {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin: 0 8px 8px 0;
    min-width: 65px;
    height: 65px;
    border: 1px solid #d8e4f0;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    }
}

.thumb-icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-top: 8px;
}
</style>
